import { ApkPlatform } from "../dtos";

const platformNames: {[key in ApkPlatform]: string} = {
    "X32": "32 bit",
    "X64": "64 bit"
};

export const getPlatformName = (platform: ApkPlatform) => platformNames[platform];